import { Button } from '@octano/global-ui';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../../../../components/text';
import useUserState from '../../../../../../hooks/useUserState';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { PermissionName } from '../../../../../../types/Auth';
import StudentObservationCreateModal, {
  StudentObservationModalMethods,
} from '../../../../../updateStudentFile/parts/StudentObservations/parts/StudentObservationCreateModal';
import StudentObservationsTable from '../../../../../updateStudentFile/parts/StudentObservations/parts/StudentObservationsTable';

const StudentObservations = () => {
  const { studentId } = useParams<{ studentId: string }>();
  const { isAuthorizedTo } = useUserState();

  const { t } = useTranslation(
    TranslationsKeys.STUDENT_WARNINGS_STUDENT_OBSERVATIONS,
  );

  const studentObservationModalRef = useRef<StudentObservationModalMethods>(
    null,
  );

  const hasPermission = useMemo(
    () =>
      isAuthorizedTo(
        [PermissionName.STUDENT_MANAGEMENT_STUDENT_FILE_MANAGE],
        true,
      ),
    [isAuthorizedTo],
  );

  return (
    <>
      <Row className="d-flex justify-content-between align-items-center mt-4">
        <Col xs="auto">
          <SectionTitle text={t('list.tableTitle')} />
        </Col>
        {hasPermission && (
          <Col xs="auto">
            <Button
              text={t('list.actions.createObservation')}
              className="ml-2"
              color="primary"
              type="button"
              icon="plus"
              size="md"
              outlined
              onClick={() => {
                studentObservationModalRef?.current?.open();
              }}
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col xs={12}>
          <StudentObservationsTable refModal={studentObservationModalRef} />
        </Col>
      </Row>

      <StudentObservationCreateModal
        studentId={studentId}
        ref={studentObservationModalRef}
      />
    </>
  );
};

export default StudentObservations;
